import React from 'react';

import Indicators  from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Indicators/List.js';

export default function () {
  return <Indicators  />;
}